import { Typography } from "@mui/material";
import { useFormikContext } from "formik";
import { useMemo } from "react";
import useColors from "../../../../../../api/hooks/useColors";
import { StyledTextField } from "../../../../../../components/forms/styles/formFieldStyles";

const JiraSummary = ({ required = true }) => {
  const colors = useColors();
  const { values, errors, touched, handleBlur, setFieldValue } =
    useFormikContext();

  const hasError = touched.issueSummary && !!errors.issueSummary;
  const errorMessage =
    hasError && typeof errors.issueSummary === "string"
      ? errors.issueSummary
      : "";

  const summaryLabel = useMemo(() => {
    const hasValue = values.issueSummary?.trim();
    const labelText = hasValue ? "Issue summary" : "Select issue summary";

    return <Typography variant="caption">{labelText}</Typography>;
  }, [values.issueSummary]);

  return (
    <StyledTextField
      margin="dense"
      name="issueSummary"
      label={summaryLabel}
      fullWidth
      required={required}
      value={values.issueSummary}
      onChange={(event) => setFieldValue("issueSummary", event.target.value)}
      error={hasError}
      helperText={errorMessage}
      onBlur={handleBlur}
      sx={{
        "& .MuiOutlinedInput-root": {
          backgroundColor: colors.textfield_outlined_enabled_auto_generated_bg,
        },
      }}
    />
  );
};
export default JiraSummary;
